// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"11bc091b","451":"12bde4bd","453":"453f2ef2","667":"b14661fa"}[chunkId] + ".chunk.js";
};